import React, { useEffect, useState } from "react";
import { usePopper } from "react-popper";
import MarkdownIcon from "../../Assets/svgs/MarkdownIcon";
import PdfIcon from "../../Assets/svgs/PdfIcon";
import TxtIcon from "../../Assets/svgs/TxtIcon";
import WordIcon from "../../Assets/svgs/WordIcon";
import { emailValidation, nameValidation, validURL } from "../Validations";
import useDidMountEffect from "../useDidMountEffect";
import { isValidPhoneNumberWithCountryCode } from "../utils";
import DateCell from "./DateCell";
import Relationship from "./Relationship";
import { grey } from "./colors";
import PlusIcon from "./img/Plus";
import { randomColor } from "./utils";

export default function Cell(props) {
  const {
    value: initialValue,
    row: { index },
    column: { id, dataType, options, required },
    dataDispatch,
    isError,
    isAllSelected,
  } = props;
  const [value, setValue] = useState({ value: initialValue, update: false });
  const [error, setError] = useState("");
  const [selectRef, setSelectRef] = useState(null);
  const [selectPop, setSelectPop] = useState(null);
  const [showSelect, setShowSelect] = useState(false);
  const onChange = (e) => {
    const type = e.target.type;
    const currentValue =
      type == "checkbox" ? e?.target?.checked : e.target.value;
    let currError = "";
    if (dataType == "email" || id == "email") {
      const isValid = emailValidation(currentValue);
      currError =
        isValid || currentValue.trim() === "" || currentValue.trim() === "<br>"
          ? ""
          : "Please enter valid Email";
    } else if (dataType == "url") {
      const isValid = validURL(currentValue);
      currError =
        isValid || currentValue.trim() === "" || currentValue.trim() === "<br>"
          ? ""
          : "Please enter valid url";
    } else if (dataType == "phone") {
      const isValid = isValidPhoneNumberWithCountryCode(currentValue);
      currError =
        isValid || currentValue.trim() === "" || currentValue.trim() === "<br>"
          ? ""
          : "Please enter valid phone no";
    } else if (dataType == "phoneNo") {
      const regex = /^\d{7,12}$/;
      currError =
        currentValue.trim() === "" ||
        currentValue.trim() === "<br>" ||
        regex.test(currentValue)
          ? ""
          : "Please enter valid phone no";
    } else if (dataType == "countryCode") {
      currError =
        currentValue == "91" || currentValue == "61" || currentValue == "64"
          ? ""
          : "Invalid country code. Allowed: 61, 64, 91";
    } else if (
      id === "first_name" ||
      id == "last_name" ||
      id === "firstName" ||
      id === "lastName"
    ) {
      const isValid = nameValidation(currentValue);
      currError =
        isValid || currentValue.trim() === "" || currentValue.trim() === "<br>"
          ? ""
          : "Please enter valid name";
    }
    setError(currError);
    setValue({ value: currentValue, update: false });
    if (currError != error) {
      dataDispatch({ type: "SET_ERROR", payload: currError ? true : false });
    }
    if (dataType == "checkbox-select") {
      setValue({ value: currentValue, update: true });
    }
  };

  const [showAdd, setShowAdd] = useState(false);
  const [addSelectRef, setAddSelectRef] = useState(null);
  const isDisabled = isError && !error;

  useEffect(() => {
    setValue({ value: initialValue, update: false });
  }, [initialValue]);

  useDidMountEffect(() => {
    if (dataType == "checkbox-select") {
      setValue({ value: isAllSelected, update: false });
    }
  }, [isAllSelected]);

  useEffect(() => {
    if (value.update && !error) {
      dataDispatch({
        type: "update_cell",
        columnId: id,
        rowIndex: index,
        value: value.value,
      });
    }
  }, [value, dataDispatch, id, index]);

  function handleOptionKeyDown(e) {
    if (e.key === "Enter") {
      if (e.target.value !== "") {
        dataDispatch({
          type: "add_option_to_column",
          option: e.target.value,
          backgroundColor: randomColor(),
          columnId: id,
        });
      }
      setShowAdd(false);
    }
  }

  function handleAddOption(e) {
    setShowAdd(true);
  }

  function handleOptionBlur(e) {
    if (e.target.value !== "") {
      dataDispatch({
        type: "add_option_to_column",
        option: e.target.value,
        backgroundColor: randomColor(),
        columnId: id,
      });
    }
    setShowAdd(false);
  }

  const checkAndAddProtocolUrl = (url) => {
    const hasProtocol = url.startsWith("http://") || url.startsWith("https://");
    const finalUrl = hasProtocol ? url : `https://${url}`;
    return finalUrl;
  };

  const { styles, attributes } = usePopper(selectRef, selectPop, {
    placement: "bottom-start",
    strategy: "fixed",
  });

  function getColor() {
    let match = options.find((option) => option.label === value.value);
    return (match && match.backgroundColor) || grey(300);
  }

  useEffect(() => {
    if (addSelectRef && showAdd) {
      addSelectRef.focus();
    }
  }, [addSelectRef, showAdd]);

  let element;
  switch (dataType) {
    case "text":
    case "email":
    case "phone":
    case "phoneNo":
    case "countryCode":
    case "url":
      element = (
        <input
          value={(value.value && value.value.toString()) || ""}
          onChange={onChange}
          onBlur={() => setValue((old) => ({ value: old.value, update: true }))}
          disabled={isDisabled}
          style={{ background: isDisabled ? "#D2D6DB80" : "transparent" }}
          className="data-input"
        />
      );
      break;
    case "date":
      element = (
        <DateCell
          value={(value.value && value.value.toString()) || ""}
          onChange={onChange}
          isDisabled={isDisabled}
          setValue={(val) => setValue({ value: val, update: true })}
        />
      );
      break;
    case "number":
      element = (
        <input
          value={(value.value && value.value.toString()) || ""}
          onChange={onChange}
          onBlur={() => setValue((old) => ({ value: old.value, update: true }))}
          disabled={isDisabled}
          style={{ background: isDisabled ? "#D2D6DB80" : "transparent" }}
          className="data-input"
        />
      );
      break;
    case "number":
      element = (
        <input
          value={(value.value && value.value.toString()) || ""}
          onChange={onChange}
          onBlur={() => setValue((old) => ({ value: old.value, update: true }))}
          style={{ background: isDisabled ? "#D2D6DB80" : "transparent" }}
          disabled={isDisabled}
          className="data-input"
        />
      );
      break;
    case "checkbox-select":
      element = (
        <input
          checked={value.value ?? false}
          onChange={onChange}
          style={{
            background: isDisabled ? "#D2D6DB80" : "transparent",
            width: "20px",
            height: "20px",
            accentColor: "#8b58f1"
          }}
          disabled={isDisabled}
          type="checkbox"
          className="data-input text-align-right"
        />
      );
      break;
    case "select":
      element = (
        <>
          <div
            ref={setSelectRef}
            className="cell-padding d-flex cursor-default align-items-center flex-1"
            onClick={() => setShowSelect(true)}
          >
            {value.value && (
              <Relationship value={value.value} backgroundColor={getColor()} />
            )}
          </div>
          {showSelect && (
            <div className="overlay" onClick={() => setShowSelect(false)} />
          )}
          {showSelect && (
            <div
              className="shadow-5 bg-white border-radius-md"
              ref={setSelectPop}
              {...attributes.popper}
              style={{
                ...styles.popper,
                zIndex: 4,
                minWidth: 200,
                maxWidth: 320,
                padding: "0.75rem",
              }}
            >
              <div
                className="d-flex flex-wrap-wrap"
                style={{ marginTop: "-0.5rem" }}
              >
                {options.map((option) => (
                  <div
                    className="cursor-pointer"
                    style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}
                    onClick={() => {
                      setValue({ value: option.label, update: true });
                      setShowSelect(false);
                    }}
                  >
                    <Relationship
                      value={option.label}
                      backgroundColor={option.backgroundColor}
                    />
                  </div>
                ))}
                {showAdd && (
                  <div
                    style={{
                      marginRight: "0.5rem",
                      marginTop: "0.5rem",
                      width: 120,
                      padding: "2px 4px",
                      backgroundColor: grey(200),
                      borderRadius: 4,
                    }}
                  >
                    <input
                      type="text"
                      className="option-input"
                      onBlur={handleOptionBlur}
                      ref={setAddSelectRef}
                      onKeyDown={handleOptionKeyDown}
                    />
                  </div>
                )}
                <div
                  className="cursor-pointer"
                  style={{ marginRight: "0.5rem", marginTop: "0.5rem" }}
                  onClick={handleAddOption}
                >
                  <Relationship
                    value={
                      <span className="svg-icon-sm svg-text">
                        <PlusIcon />
                      </span>
                    }
                    backgroundColor={grey(200)}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      );
      break;
    case "upload":
      const splittedFieldData = (value?.value ?? "")?.split("/");
      const fileName = splittedFieldData?.length
        ? splittedFieldData[splittedFieldData?.length - 1]
        : "";
      const fileTypeList = fileName?.split(".");
      const fileNameWithoutExtension =
        fileTypeList?.length && fileTypeList?.length > 1
          ? fileTypeList
              ?.filter((_item, index) => index != fileTypeList?.length - 1)
              .join("")
          : "";
      const formattedFileName =
        fileNameWithoutExtension?.length > 3
          ? fileNameWithoutExtension?.slice(0, 3) +
            ".." +
            fileNameWithoutExtension?.slice(
              fileNameWithoutExtension?.length - 3,
              fileNameWithoutExtension?.length - 1
            )
          : "";
      const fileType = fileTypeList?.length
        ? fileTypeList[fileTypeList?.length - 1]
        : "";
      element = value?.value ? (
        <a
          href={checkAndAddProtocolUrl(value?.value)}
          target="_blank"
          rel="noopener noreferrer"
        >
          <p>
            {fileType == "txt" ? (
              <TxtIcon width={21} height={21} />
            ) : fileType == "md" ? (
              <MarkdownIcon width={21} height={21} />
            ) : fileType == "doc" || fileType == "doc" ? (
              <WordIcon width={21} height={21} />
            ) : (
              <PdfIcon width={21} height={21} />
            )}{" "}
            {formattedFileName}.{fileType}
          </p>
        </a>
      ) : (
        ""
      );
      break;
    default:
      element = <span></span>;
      break;
  }

  // return (
  //   <span
  //     style={{
  //       display: "block",
  //       border: error ? "1px solid #ff0000" : "none",
  //       background: error ? "rgba(255, 0, 0, 0.1)" : "transparent",
  //       position: "relative",
  //       padding: error ? "2px" : "0",
  //       borderRadius: "2px",
  //       transition: "all 0.2s ease",
  //     }}
  //   >
  //     {element}
  //   </span>
  // );

  return (
    <div
      style={{
        position: "relative",
        background: isDisabled ? "#D2D6DB80" : "transparent",
        borderRadius: "4px",
        height: "100%",
      }}
    >
      <span
        style={{
          display: dataType == "checkbox-select" ? "flex" : "block",
          border: error ? "1px solid #ff0000" : "none",
          background: error ? "rgba(255, 0, 0, 0.1)" : "transparent",
          position: "relative",
          padding: error ? "2px" : "0",
          borderRadius: "2px",
          transition: "all 0.2s ease",
          height: dataType == "checkbox-select" ? "100%" : "auto",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {element}
      </span>
      {error && (
        // || (required && (!value.value || value.value == "<br>"))
        <div
          style={{
            color: "#ff0000",
            fontSize: "12px",
            fontWeight: "400",
            whiteSpace: "normal", // Changed from nowrap to normal
            zIndex: 999,
            display: "flex",
            alignItems: "flex-start", // Changed from center to flex-start
            gap: "4px",
            animation: "slideIn 0.2s ease-in-out",
            backgroundColor: "#fff",
            padding: "2px 4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            borderRadius: "4px",
            maxWidth: "200px", // Add maximum width
            width: "fit-content", // Changed from max-content to fit-content
            lineHeight: "1.2", // Add line height for better readability
            wordBreak: "break-word", // Add word break for long words
          }}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="currentColor"
            style={{
              marginTop: "2px", // Align icon with first line of text
              flexShrink: 0, // Prevent icon from shrinking
            }}
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          {error ? error : "This Field is required."}
        </div>
      )}
      <style>
        {`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-5px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}
      </style>
    </div>
  );
}
